export const removeFrontZero = (data) => {
  if(data && data[0] === '0') {
    return data.slice(1);
  }
  return data
}

export const orderByBsswgh = (data) => {
  return data.sort((a, b) => a.BSSWGH - b.BSSWGH)
}

export const roundNumber = (num, decimalDigit) => {
  if(isNaN(num)) {
    return num;
  }
  const result = Math.round(num * (10**decimalDigit)) / (10 ** decimalDigit)
  if(isNaN(result)) {
    return num
  }
  return result;
}